import { useScrollReset } from 'src/hooks';

const ScrollReset = () => {
  useScrollReset();

  return null;
};

export default ScrollReset;
